import type { CrmLabel } from '../../lib/types/customers.js';
import { labelChipStyle } from '../../lib/crmLabels.js';
import './crmLabels.css';

/** Read-only coloured chips. Renders nothing for an empty set so callers need no guard. */
export function LabelChips({
  labels,
  max,
}: {
  readonly labels: readonly CrmLabel[] | undefined;
  /** Show at most this many, then a «+N» chip (dense lists). */
  readonly max?: number;
}) {
  if (!labels || labels.length === 0) return null;
  const shown = max === undefined ? labels : labels.slice(0, max);
  const hidden = labels.length - shown.length;
  return (
    <span className="crm-labels" aria-label="برچسب‌ها">
      {shown.map((label) => (
        <span
          key={label.labelId}
          className="crm-label"
          style={labelChipStyle(label.color)}
          data-inactive={label.status === 'inactive' ? 'true' : undefined}
        >
          {label.name}
        </span>
      ))}
      {hidden > 0 ? (
        <span
          className="crm-label"
          title={labels
            .slice(max)
            .map((l) => l.name)
            .join('، ')}
        >
          +{hidden.toLocaleString('fa-IR')}
        </span>
      ) : null}
    </span>
  );
}
